/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import LineChart from 'loracoms/LineChart';

class ParsedDataTrend extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      list: props.list,
      metrics: props.metrics,
      series: null,
    };
  }

  componentWillMount() {
    this.setState({ series: this.handleSeries(this.state.list) });
  }

  componentWillReceiveProps(nextProps) {
    const { list, metrics, dataPoints } = nextProps;
    if (list !== this.props.list) {
      this.setState({ list, series: this.handleSeries(list) });
    }
    if (metrics !== this.props.metrics) {
      this.setState({ metrics });
    }
    if (dataPoints !== this.props.dataPoints) {
      this.setState({ list, series: this.handleSeries(list) });
    }
  }
  handleSeries(l) {
    let list = l.reverse();
    if (Date.parse(l[0].timestamp) > Date.parse(l[l.length - 1].timestamp)) {
      list = l.reverse();
    }
    const obj = { categories: [], series: {} };
    const { dataPoints } = this.props;
    dataPoints.forEach((key) => {
      obj.series[key] = { name: key, data: [], yAxisIndex: 0 };
    });
    const handleMetrics = (arr) => {
      dataPoints.forEach((key) => {
        obj.series[key].data.push(arr[key]);
      });
    };
    list.forEach((item) => {
      handleMetrics(item.metrics);
      obj.categories.push(format(item.timestamp, 'DD/MM HH:mm:ss'));
    });
    return obj;
  }

  render() {
    const { metrics, series } = this.state;
    const originData = series.series[metrics];
    const categories = series.categories;
    const validData = [];
    const validTime = [];
    originData.data.forEach((item, index) => {
      if (item) {
        validData.push(item);
        validTime.push(categories[index]);
      }
    });
    const newData = { ...originData, data: validData };
    if (series) {
      return (
        <div>
          <LineChart
            yAxis={[{
              name: metrics,
              splitNumber: 5,
            }]}
            xAxis={{
              axisTick: {
                alignWithLabel: true,
              },
              boundaryGap: true,
            }}
            series={[newData]}
            categories={validTime}
            grid={{
              left: 60,
              top: 30,
              right: 30,
              bottom: 60,
            }}
          />
        </div>
      );
    }
    return null;
  }
}

ParsedDataTrend.propTypes = {
  list: PropTypes.array.isRequired,                        //eslint-disable-line
  metrics: PropTypes.string.isRequired,
  dataPoints: PropTypes.array.isRequired,                  //eslint-disable-line
};

export default ParsedDataTrend;




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DataToolView/coms/ParsedDataTrend/index.jsx